import { Link } from "react-router-dom";

const SOCIALS = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-youtube-fill", label: "视频号" },
  { icon: "ri-instagram-line", label: "Instagram" },
];

const QUICK_LINKS = [
  { label: "影视资讯", to: "/news" },
  { label: "影视作品", to: "/works" },
  { label: "演员介绍", to: "/actors" },
  { label: "关于筱田优", to: "/about" },
];

const FRIEND_LINKS = ["上海国际电影节", "亚洲电影资料馆", "光影放映厅", "青年影像计划"];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-50 mt-20">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-background-50 text-lg font-bold">
                筱
              </span>
              <span className="font-heading text-xl font-bold">筱田优</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/80 max-w-md">
              筱田优影视品牌官方网站，提供最新的影视资讯、作品介绍及相关动态，涵盖电影电视剧资源和演员资料，满足影迷对筱田优全方位的了解需求。
            </p>
            <div className="flex items-center gap-3 mt-6">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href="#"
                  title={s.label}
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800 text-primary-50 hover:bg-accent-500 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4 text-background-50">
              <a href="#footer-nav">快速导航</a>
            </h4>
            <ul className="space-y-3 text-sm">
              {QUICK_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-primary-100/80 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold mb-4 text-background-50">
              <a href="#footer-friend">友情链接</a>
            </h4>
            <ul className="space-y-3 text-sm">
              {FRIEND_LINKS.map((link) => (
                <li key={link}>
                  <a href="#" className="text-primary-100/80 hover:text-accent-300 transition-colors">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-100/70">
          <p>© 2026 筱田优影视品牌官方站 · 本站内容为演示示例，仅用于展示</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-accent-300 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-accent-300 transition-colors">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}